@if (isLoading) {
  <app-rings-loader></app-rings-loader>
}
<div class="modal-header">
  <h3 class="dialog-title text-center">{{title | translate}}</h3>
</div>
<div mat-dialog-content>
  <div class="modal-content">
    <div class="logo-img-container">
      <img src="assets/images/grpLogo.svg" alt="" class="logo-img">
    </div>
    <app-progress-spinner [show]="isFormLoading"></app-progress-spinner>
    <div class="modal-body">
      <div>
        <div class="form-fields-body">
          <div class="row">
            @for (field of fields; track trackByIndex($index)) {
              <app-dynamic-form-field [field]="field" [entity]="entity"></app-dynamic-form-field>
            }
          </div>

        </div>
        <div mat-dialog-actions class="createButton mt-2">
          @if (!isReadonly) {
            <button class="btn modal-footer-btn save-modal-btn" (click)="save()"
              [class.cursor-not-allowed]="isLoading">
              {{ 'Save & Link' | translate}}
            </button>
          }

          <div class="createButton mt-3">
            <button class="btn modal-footer-btn cancel-modal-btn" (click)="skipLinking()">
              {{ 'Skip Linking' | translate}}
            </button>
          </div>
          <div class="createButton mt-3">
            <button class="btn modal-footer-btn cancel-modal-btn" (click)="cancel()">
              {{ 'Cancel' | translate}}
            </button>
          </div>
        </div>

      </div>
    </div>
  </div>